// Ignore intentional dynamic keys
const i18nIgnoredKeys = [
    'insightDescriptionI18nKey',
    'verificationModalBodyI18nKey',
    'verificationModalTitleI18nKey',
    'trendsAdminMessageI18nKey',
    'trendsNonAdminMessageI18nKey',
    'deleteModalKeyPath',
    'dashboardSignalsConfirmationKey',
];

export const DEFAULT_LOCALE = 'en';

export const SUPPORTED_LOCALES = ['en', 'ja', 'de', 'pt-BR', 'es'];

export const UNANNOUNCED_LOCALES = ['fr-FR'];

export default {
    localePath: 'src/utils/i18n/locales',
    outputPath: './src/locales',
    srcPath: './src',
    dependentLocalePaths: [
        '../node_modules/@pendo/components/lib/es/locales',
        '../login/dist/es/locales',
        '../node_modules/@pendo/one-ui-shared/dist/es/locales',
        '../node_modules/@pendo/tagging/dist/locales',
    ],
    check: {
        ignore: {
            files: [], // Files to skip when checking for new $t strings; allows glob pattern
            keys: i18nIgnoredKeys, // Strings or context paths to skip when checking for new $t strings
        },
    },
};